import { moduleFile } from "@lib/appconst"
import fileService from "@services/common/fileService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import unitTypeService from "@services/master-data/unitTypeService"
import { action, makeAutoObservable, observable } from "mobx"

class UnitTypeStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable listData!: any
  @observable listDataChild!: any
  @observable validateData!: any
  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
    this.listData = []
    this.listDataChild = []
    this.validateData = []
  }

  @action
  async createOrUpdate(body: any, files?: any) {
    const result = await unitTypeService.createOrUpdate(body)
    this.detailData = result
    const { uniqueId } = result
    if (files && files.length && uniqueId) {
      files.forEach(async (file) => {
        if (file.originFileObj !== undefined) {
          const fileUpload = file.originFileObj
          await fileService.upload(moduleFile.unitType, uniqueId, fileUpload)
        }
      })
      this.isLoading = false
    }

    if (!body.id) {
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
  }

  @action
  async emptyDetail() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async active(id: number, isActive) {
    await unitTypeService.activate(id, isActive)
  }

  @action
  async get(id: number) {
    const result = await unitTypeService.get(id)
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await unitTypeService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
  @action
  async getList(params: any) {
    this.isLoading = true
    const result = await unitTypeService
      .getList(params)
      .finally(() => (this.isLoading = false))
    this.listData = result
  }

  @action
  async getListChildren(params: any) {
    this.isLoading = true
    const result = await unitTypeService
      .getListChildren(params)
      .finally(() => (this.isLoading = false))
    this.listDataChild = result
  }

  @action
  async validateBeforeImport(file: File) {
    this.isLoading = true
    try {
      const result = await unitTypeService
        .validateBeforeImport(file)
        .finally(() => (this.isLoading = false))
      // ReviewImportExcelV2 expects { datas, errors }
      const datas = result?.datas ?? result?.data ?? []
      const errors = result?.errors ?? []
      return { datas, errors }
    } catch (error) {
      this.isLoading = false
      throw error
    }
  }

  @action
  async importUnitType(datas: Array<{ id?: number; name?: string; code?: string; rowNumber?: number }>) {
    this.isLoading = true
    try {
      await unitTypeService
        .importUnitType(datas)
        .finally(() => (this.isLoading = false))
    } catch (error) {
      this.isLoading = false
      throw error
    }
  }

  @action
  async emptyValidateData() {
    this.validateData = []
  }
}

export default UnitTypeStore
